import request from '@/utils/request'


//积分换货验证
export function verificationJFHH(query) {
    return request({
        url: 'order/verificationJFHH',
        method: 'get',
        params: query
    })
}
//积分换货商品列表
export function goodsListJFHHByMember(query) {
    return request({
        url: 'order/goodsListJFHHByMember',
        method: 'get',
        params: query
    })
}
//积分换货购买
export function saveJFHH(data) {
    return request({
        url: 'order/saveJFHH',
        method: 'post',
        data
    })
}
